import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@src/shared/types/base-query';
import type { TLabel } from '@src/shared/types/label';

export type TLabelQuery = TBaseQuery;

const labelApi = createCrudService<TLabel, TLabelQuery, Partial<TLabel>>({
  queryKey: [QUERY_KEYS.getLabels],
  url: 'labels',
});

export default labelApi;
